import Icon, { ICONS } from "components/common/Icons";
import BottomModal from "components/common/Modal/BottomModal";
import Button from "components/common/buttons/buttons";
import { useState } from "react";
import { useTranslation } from "next-i18next";
import { TYPO } from "styles/Typo";
import useModalClickOutside from "utils/useModalClickOutside";
import Image from "next/image";
import Lottie from "lottie-react";
import alarmAnimation from "../../../public/lottie/alarm.json";

function RiskAlarmNotiModal({
  setModalOpen,
  isModalOpen,
  setAlarmRegister,
}: any) {
  const modalRef = useModalClickOutside(setModalOpen);
  const [description, setDescription] = useState(false);
  const { t } = useTranslation("detail");
  return (
    <BottomModal
      isOpen={isModalOpen}
      modalRef={modalRef}
      containerClass="gap-[24px] !z-[900]"
    >
      <div className="flex flex-col gap-2">
        <h1 className={`${TYPO.TYPO4_B} text-gray80 whitespace-pre-line`}>
          {t("riskRegisterModalTitle")}
        </h1>
        <span className={`${TYPO.TYPO7_MD} text-gray50`}>
          {t("messageOrEmail")}
        </span>
      </div>
      <div className="w-full items-center justify-center flex mb-[6px]">
        <Lottie
          animationData={alarmAnimation}
          renderer="svg"
          autoplay
          loop
          style={{ width: 120, height: 120 }}
        />
      </div>
      <div className="w-full flex gap-2 z-[100]">
        <Button
          type={"text_gray"}
          size={"xl"}
          text={t("later")}
          width="grow-[0.5]"
          clickHandler={() => {
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            localStorage.setItem("hideModal", tomorrow.toISOString());
            setModalOpen(false);
          }}
        />
        <Button
          type={"primary"}
          size={"xl"}
          text={t("notifyMe")}
          width="grow-[0.5]"
          clickHandler={() => {
            setAlarmRegister(true);
            setModalOpen(false);
          }}
        />
      </div>
    </BottomModal>
  );
}
export default RiskAlarmNotiModal;
